import verifyCpfCnpj from "../../../utils/validators/IsValidCpfCnpj";
import IsValidPhone from "../../../utils/validators/IsValidPhone";
import IsValidEmail from "../../../utils/validators/IsValidEmail";

export const handleInputCpf = (props) => {
    let value = props.e.replace(/\D/g, "");
    if (value.length > 14) {
        return
    }
    if (value.length < 1) {
        props.setCpfCnpj(value);
        props.setCpfCnpjError("");
        props.setCpfCnpjRole("ok");
    } else if (!verifyCpfCnpj(value)?.isValid) {
        props.setCpfCnpjError("Não é um CPF/CNPJ válido.");
        props.setCpfCnpjRole("notOk");
        props.setFormattedCpfCnpj(value);
    } else {
        props.setCpfCnpjError("");
        props.setCpfCnpjRole("ok");
        props.setFormattedCpfCnpj(value);
    }
}

export const handleInputPhone = (props) => {
    let value = props.e.replace(/\D/g, "");
    if (value.length > 11) {
        return;
    }
    props.setPhone(value);
    if (value.length < 1) {
        props.setPhone(value);
        props.setPhoneError("");
        props.setPhoneRole("ok");
    } else if (!IsValidPhone(value)) {
        props.setPhone(value);
        props.setPhoneError("Não é um telefone válido.");
        props.setPhoneRole("notOk");
    } else {
        props.setPhoneError("");
        props.setPhoneRole("ok");
        if (value.length === 11) {
            props.setPhone(value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3"));
        } else if (value.length === 10) {
            props.setPhone(value.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3"));
        } else {
            props.setPhone(value);
        }
    }
};

export const handleInputName = (props) => {
    if (!props.name) {
        props.setName();
        props.setNameError("Campo obrigatório");
        props.setNameRole("notOk");
    } else {
        props.setName(props.name);
        props.setNameError("");
        props.setNameRole("ok");
    }
};

export const handleInputEmail = (props, e) => {
    if (e.length < 1) {
        props.setEmail(e);
        props.setEmailError("Campo obrigatório");
        props.setEmailRole("notOk");
    } else if (!IsValidEmail(e)) {
        props.setEmail(e);
        props.setEmailError("Não é um E-mail válido.");
        props.setEmailRole("notOk");
    } else {
        props.setEmail(e);
        props.setEmailError("");
        props.setEmailRole("ok");
    }
};
